<template>
  <div :style="{background}" :class="`background ${isMobile ? 'mobile': 'desktop'}`">
    <PluginSlot name="loginToolbar" />
    <div class="card">
      <div v-if="forgotPasswordMode === false">
        <header>
          <p class="card-title">
            {{ i18n.login }}
          </p>
        </header>
        <section class="card-body">
          <b-message v-if="loginError" class="error-message" type="is-danger" has-icon @click.native="$store.dispatch('login/setLastError', undefined)">
            <span v-if="loginError.message">{{ i18n[loginError.message] }}</span>
            <span v-else>{{ i18n[loginError] }}</span>
          </b-message>
          <div class="field">
            <label class="label">{{ i18n.username }}</label>
            <b-input
              ref="mainInput"
              v-model="username"
              :placeholder="i18n.your_username"
              type="text"
              class="username-input"
              required
              @keyup.enter.native="login"
            />
          </div>
          <div class="field">
            <label class="label">{{ i18n.password }}</label>
            <b-input
              v-model="password"
              :placeholder="i18n.your_password"
              type="password"
              class="password-input"
              password-reveal
              required
              @keyup.enter.native="login"
            />
          </div>
          <div class="field" v-if="displayApiSelector">
            <label class="label">API endpoint</label>
            <b-input
              v-model="apiEndpoint"
              type="text"
              required
              @keyup.enter.native="login"
            />
          </div>
        </section>
        <footer class="card-foot">
          <button
            :class="loading ? 'button is-primary is-loading' : 'button is-primary'"
            @click="login"
          >
            {{ i18n.login }}
          </button>
          <a v-if="showForgotPasswordLink" @click="forgotPasswordMode = true">
            {{ i18n.forgot_password }}
          </a>
        </footer>
      </div>
      <div v-else>
        <header class="card-head">
          <p class="card-title">
            {{ i18n.reset_password }}
          </p>
        </header>
        <section class="card-body">
          <b-message v-if="loginError" type="is-danger" has-icon>
            {{ loginError }}
          </b-message>
          <div class="field">
            <label class="label">{{ i18n.email }}</label>
            <b-input
              v-model="email"
              type="text"
              placeholder="Your email"
              required
              @keyup.enter.native="sendResetPasswordRequest"
            />
          </div>
        </section>
        <footer class="card-foot">
          <button
            :class="loading ? 'button is-primary is-loading' : 'button is-primary'"
            @click="sendResetPasswordRequest"
          >
            {{ i18n.reset_password }}
          </button>
          <a @click="forgotPasswordMode = false">Return to login</a>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import PluginSlot from '@/components/PluginSlot';
import Api from '@/core/Api';
import i18n from 'i18n/pages/login.json';
import { isMobile } from 'mobile-device-detect';
import redirect from '@/core/utils/redirect';

export default {
  name: 'LoginPage',
  layout: 'empty',
  components: {
    PluginSlot,
  },
  data() {
    return {
      isMobile,
      i18n,
      showForgotPasswordLink: true,
      displayApiSelector: process.env.VUE_APP_LOGIN_API_SELECTOR,
      apiEndpoint: localStorage.getItem('apiEndpoint'),
      username: '',
      password: '',
      email: '',
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.login.loginLoading,
      loginError: (state) => state.login.lastError,
      user: (state) => state.login.user,
    }),
    background() {
      return `url(${process.env.VUE_APP_BACKGROUND || '/bg-login-default.jpg'})`;
    },
    forgotPasswordMode: {
      get() {
        return this.$store.state.login.forgotPasswordMode;
      },
      set(v) {
        this.$store.commit('login/setForgotPasswordMode', v);
      },
    },
    isVisible: {
      get() {
        return this.$store.state.login.modalVisible;
      },
      set(val) {
        this.email = '';
        this.$store.dispatch('login/setModalVisible', val);
      },
    },
  },
  watch: {
    user(v) {
      if (v) {
        let { redirectFrom } = this.$router.currentRoute.query;
        if (redirectFrom === '/login') {
          redirectFrom = '/';
        }

        console.log('will redirect', redirectFrom);

        redirect(this.$router, [redirectFrom || '/']);
      }
    },
  },
  methods: {
    login() {
      if (this.displayApiSelector && this.apiEndpoint && this.apiEndpoint !== '') {
        Api.axios.defaults.baseURL = this.apiEndpoint;
        localStorage.setItem('apiEndpoint', this.apiEndpoint);
      }
      this.$store.dispatch('login/login', {
        username: this.username,
        password: this.password,
      });
    },
    sendResetPasswordRequest() {
      this.$store.commit('login/setLoginLoading', true);
      Api.post('/forgot', { email: this.email }).then((response) => {
        this.$store.commit('login/setLoginLoading', false);
      }).catch((e) => {
        this.$store.commit('login/setLoginLoading', false);
      });
    },
  },
};
</script>
<style scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover !important;
  background-repeat: no-repeat !important;
}
.card {
  min-height: 340px;
  margin: auto;
  margin-top: 200px;
  width: 400px;
  padding: 20px;
}
.mobile .card {
  margin-top: 20px;
}
.card-title {
  font-size: 28px;
}
.card-title {
  padding-bottom: 14px;
}
.card-body {
  padding-bottom: 100px;
}
.card-foot {
  display: block;
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
}
.card-foot .button {
  float: right;
  margin-left: 4px;
  margin-right: 4px;
}
.error-message {
  cursor: pointer;
}
.error-message:hover {
  opacity: 0.6;
}
</style>
